// src/App.js

import './index.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { SSOSignin } from './CoreComponents/signin/SSOSignin'
import { Layout } from './CoreComponents/constants/Layout'
import { setAxiosDefauls } from './middleware/interceptor'
import { inkapi } from './middleware/interceptor'
import Dashboard from './CoreComponents/Dashboard'
import Submitted from './CoreComponents/Submitted'
import Guided from './CoreComponents/Guided'
import DIY from './CoreComponents/DIY'
import Published from './CoreComponents/Published'
import PrintOrders from './CoreComponents/PrintOrders'
import All from './CoreComponents/Table/All'
import PrivateRoute from './CoreComponents/PrivateRoute'
setAxiosDefauls()

function App () {
  const isAuthenticated = useIsAuthenticated()
  const { instance } = useMsal()
  const [Emp_Role, setEmp_Role] = useState()
  const [employee_id, setEmployee_id] = useState()
  const [Secret_key, setSecret_key] = useState('')
  const [Key, setKey] = useState()
  const [sidebor, setsidebor] = useState()



  return (
    <BrowserRouter>
      <Routes>
        <Route
          path='/'
          element={
            <SSOSignin
              isAuthenticated={isAuthenticated}
              setEmp_Role={setEmp_Role}
              Emp_Role={Emp_Role}
            />
          }
        />


        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout  setsidebor={setsidebor}/>
            </PrivateRoute>
          }
        >
          <Route path='dashboard' element={<All />} />
          <Route path='submitted' element={<Submitted />} />
          <Route path='guided' element={<Guided />} />
          <Route path='do-it-yourself' element={<DIY />} />
          <Route path='published' element={<Published />} />
          <Route path='print-orders' element={<PrintOrders />} />
        
        </Route>



      </Routes>
    </BrowserRouter>
  )
}

export default App
